import { EntityIcon } from "@/components/ui/cores";
import { PageHeader } from '@/components/ui/page-header';
import { FormActions } from '@/components/ui/form-actions';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FichaService } from '../../services';
import { Formik, FormikProps } from 'formik';
import { Card } from '@/components/ui/card';
import { Row } from '@/components/grid/row';
import { FormikAutoComplete } from '@/components/ui/autocomplete';
import { getTenant } from '@/utils/TenantUtils';

type SinistroFormPageParams = {
    
}

type FormValue = {
    seguro: any;
}

const SinistroNovoPage: React.FC<SinistroFormPageParams> = () => {
    const navigate = useNavigate();
    
    return (
        <div className="space-y-6">
        <PageHeader icon={<EntityIcon entidade="sinistro" />} title="Novo sinistro" />
        <Formik initialValues={{seguro: {id: undefined}}}
            enableReinitialize onSubmit={values => navigate(`/${getTenant()}/seguros/${values.seguro.id}/sinistro/novo`, { replace: true })}>
            {(formikProps: FormikProps<FormValue>) => {
                return (
                <>
                <Card className='p-6 shadow-none'>
                    <Row>
                        <FormikAutoComplete
                            onSearch={FichaService.autoComplete}
                            name="seguro"
                            label="Selecione o Seguro"
                            placeholder='Pesquise por descrição do seguro, veículo ou dados do segurado'
                            getOptionLabel={item => item && item.id && [
                                `${item.segurado?.nome} ${item.descricao || ''}`.trim(),
                                item.placa,
                                item.vigenciaFinal && `até ${new Date(`${item.vigenciaFinal}T00:00:00`).toLocaleDateString('pt-BR')}`
                            ].filter(Boolean).join(', ')}
                            getOptionValue={item => item}
                            getKey={item => item.id}
                            size={12} 
                            // getDetailOptionLabel={item => (
                            //     <>
                            //     Segurado: {item.segurado?.nome} - {item.segurado?.cpfCnpj}<br/>
                            //     Seguradora: {item.seguradora?.nome}<br/>
                            //     Placa: {item.placa} Vigência: {item.vigenciaInicial} até {item.vigenciaFinal}<br/>
                            //     Seguro: {item.seguro}
                            //     </>
                            // )}
                        />
                    </Row>
                    <FormActions onSave={formikProps.submitForm} saveLabel="Avançar" />
                </Card>
                </>
                )}}
        </Formik>
        </div>
    );
}

export default SinistroNovoPage;